export enum ResultStep {
  Result3D = 'result-3d',
  ResultList = 'result-list',
  Result2D = 'result-2d',
  NONE = '',
}
